import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class CivilianSettings
{
	public id: string;
	public showInmatePortalFeatures: boolean;
}

@Injectable()
export class CivilianSettingsRepository
{
	private requestMapping: string = "settings";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public getCivilianSettings(): Observable<CivilianSettings>
	{
		return this.http.get<CivilianSettings>(`${this.requestMapping}`);
	}
}
